<template>
  <div
    v-if="isVisible"
    class="backdrop"
    role="dialog"
    aria-labelledby="clear-dialog-title"
    aria-describedby="clear-dialog-description"
    aria-modal="true">
    <div class="clear-dialog">
      <h5 id="clear-dialog-title">
        {{ tStatic('caiClearConversationDialogTitle') }}
      </h5>
      <p id="clear-dialog-description">
        {{ tStatic('caiClearConversationDialogDescription') }}
      </p>
      <hr>
      <div class="actions">
        <button
          class="cancel"
          type="button"
          :aria-label="tStatic('CaiAccessibilityChatClearCancelInfoText')"
          @click="handleCancel">
          {{ tStatic('genericCancel') }}
        </button>
        <button
          class="submit"
          type="button"
          :aria-label="tStatic('caiAccessibilityChatClearInfoText')"
          @click="handleClear">
          {{ tStatic('genericClear') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    handleCancel: {
      type: Function,
      required: true
    },
    handleClearText: {
      type: String,
      default: ''
    },
    handleClear: {
      type: Function,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.backdrop {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
}

.clear-dialog {
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  background-color: #fff;
  z-index: 200;
  width: 80%;
  border-radius: 0.5rem;
  padding: 0.75rem;
  margin: auto;

  h5 {
    font-size: 1.25rem;
    font-weight: bold;
  }

  p {
    font-size: 13px;
  }

  hr {
    margin: 1rem 0;
  }

  .actions {
    align-self: flex-end;

    button {
      padding: 0.5rem;
      width: 6rem;
      font-size: 13px;
      font-weight: bold;
      border-radius: 1rem;
      cursor: pointer;

      &:not(:last-child) {
        margin-right: 1rem;
      }

      &.cancel {
        background: none;
        border: none;
        color: #0073bb;

        &:hover {
          background-color: #ccc;
          color: #000;
        }
      }

      &.submit {
        background-color: #1c508b;
        border: none;
        color: #fff;

        &:hover {
          background-color: #466e9c;
        }
      }
    }
  }
}</style>
